import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'
import routes from './routes'
import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use(CKEditor);
Vue.use(VueRouter);

/**
 * The Router instance containing all the routes for the application.
 */
const router = new VueRouter({
    base: '/',
    mode: 'history',
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
});



// Handle initial route from server
const appElement = document.getElementById('app');
if (appElement && appElement.dataset.initialRoute) {
    const initialRoute = appElement.dataset.initialRoute;
    if (initialRoute !== '/' && initialRoute !== router.currentRoute.path) {
        router.replace(initialRoute).catch(err => {
            if (
                err.name !== 'NavigationDuplicated' &&
                !err.message.includes('Avoided redundant navigation') &&
                !err.message.includes('Redirected when going from') &&
                !err.message.includes('Navigation cancelled from')
            ) {
                console.error(err);
            }
        });
    }
}

// Silence common navigation errors globally
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Redirected when going from') &&
            !err.message.includes('Navigation cancelled from')
        ) {
            throw err;
        }
    });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Redirected when going from') &&
            !err.message.includes('Navigation cancelled from')
        ) {
            throw err;
        }
    });
};

router.beforeEach(async (to, from, next) => {
    const store = router.app.$store;

    try {
        // Rest of the navigation logic
        const authenticated = store.getters['users/isLoggedIn'];


        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (!authenticated) {
                next({
                    path: '/landing',
                    query: { redirect: to.fullPath }
                });
            } else {
                next();
            }
        } else {
            next();
        }
    } catch (error) {
        console.error('Navigation Guard Error:', error);
        next('/landing');
    } finally {
        console.groupEnd();
    }
});

/**
 * Guard the route from unauthorized users.
 *
 * @param  {Route}    to   The route we want to access.
 * @param  {Route}    from The route from which we are coming from.
 * @param  {Function} next Callback for passing a route to be called next.
 * @return {void}
 */
function guardRoute(to, from, next) {
    //const loggedIn = !!TokenService.getToken();
    if (!store.getters['users/isLoggedIn']) {
        next({
            path: '/landing',
            query: {
                redirect: to.fullPath // Store the full path to redirect the user to after login
            }
        });
    }

    next();
}

export default router